import IconLoading from './ButtonLoading.svg?react';
import type { ButtonType } from './types';

const Button = (props: ButtonType) => {
  const {
    variant = 'block',
    theme = 'purple',
    label = '',
    iconOnly = false,
    icon = null,
    iconPosition = 'left',
    disabled = false,
    loading = false,
    type = 'button',
    size = 'md',
    fullWidth = false,
    className = '',
    onClick = null,
    ref,
  } = props;

  return (
    <button
      type={type}
      className={`theme-btn theme-btn-size-${size} ${
        fullWidth && 'theme-btn-fullwidth'
      } theme-btn-${variant} theme-btn-color-${theme} ${className}`}
      disabled={disabled || loading}
      onClick={e => {
        if (onClick !== null) {
          onClick(e);
        }
      }}
      ref={ref}
    >
      {loading && (
        <div role='status' className='theme-btn-loading'>
          <IconLoading />
        </div>
      )}
      {icon !== null && iconPosition === 'left' && icon}
      {!iconOnly && !loading && label}
      {icon !== null && iconPosition === 'right' && icon}
    </button>
  );
};

export default Button;
